import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CartContext } from '../util/cartContext';
import './styling/cart.css';
import './styling/cart-s.css';
import { Link } from "react-router-dom";
import paypal from "./assets/paypal.svg";
import visa from "./assets/visa.svg";
import mastercard from "./assets/mastercard.svg";
import ideal from "./assets/ideal.svg";
import plus from './assets/plus.svg';
import minus from './assets/minus.svg';
import trash from './assets/trash.svg';
import limoncello from "../pages/assets/limoncello.jpg";
import valenti from "../pages/assets/valenti.jpg";
import yuzu from "../pages/assets/yuzu.jpg";
import valentiCoctail from "../pages/assets/valentiCoctail.png";
import yuzuGin from "../pages/assets/gin.jpg";
import arrow from "../pages/product pages/assets/arrow-back.svg";

const Cart = () => { 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { cart, addToCart, removeFromCart, clearCart, totalPrice, shippingCost, removeItem } = useContext(CartContext);
  const [productCount, setProductCount] = useState(0);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1200px)").matches
  );
   const [hasItems, setHasItems] = useState(false);
   
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let count = 0;
    cart.map(product => {
      count += product.quantity;
    });
    setProductCount(count);
  }, [cart]);

   useEffect(() => {
      setHasItems(cart.length > 0); 
    }, [cart]); 

  const previousUrl = location.state?.from || '/webshop';

  const getProductImage = (item) => {
    return item.images?.length > 0 ? item.images[0].image_url : "https://via.placeholder.com/150";
  };
  
  return (
    <>

    {!isMobile && (
    <div className="desktopNavSpacer"></div>
     )}
       <div onClick={() => navigate(previousUrl)} className="back">        
          <img src={arrow} alt=""></img>
          <p>Terug</p>
      </div>
    <div id='cartWrapper'>
    <div id='cartBox'>
      <h2>Winkelwagentje</h2>
      <div className="cart-content">
        <div className="cart-items">
          {cart.length === 0 ? (
            <p>Het winkelwagentje is leeg</p>
          ) : (
            <ul>
            {cart.map(item => (
                  <li key={item.id}>
                    <div className="item-info">
                      <div className='item-info-imageWrapper'>
                      <img src={getProductImage(item)} alt={item.name} className="product-image" />
                      </div>
                      <div className='item-info-text'>
                        <h3>{item.name}</h3>
                        <p>Prijs: €{item.price}</p>
                        {isMobile && (
                          <div className="quantity-controls">
                      <button onClick={() => removeFromCart(item.name)}><img src={minus} alt='-' /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => addToCart(item, 1)}><img src={plus} alt='+' /></button>
                      <button className="remove-item-btn" onClick={() => removeItem(item.name)}><img src={trash} alt='Verwijder' /></button>
                    </div>
                        )}
                      </div>
                    </div>

                    {!isMobile && (
                    <div className="quantity-controls">
                      <button onClick={() => removeFromCart(item.name)}><img src={minus} alt='-' /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => addToCart(item, 1)}><img src={plus} alt='+' /></button>
                      <button className="remove-item-btn" onClick={() => removeItem(item.name)}><img src={trash} alt='Verwijder' /></button>
                    </div>
                    )}
                  </li>
                ))}
            </ul>
          )}
          {cart.length > 0 && (
            <div className="cart-actions">
              <p onClick={clearCart} className="clear-cart-btn "><img src={trash} alt='Verwijder' /> Winkelwagentje legen</p>
            </div>
          )}
        </div>
        <div data-aos="zoom-in" className="cart-overview">
          <h2>Overzicht</h2>
          <div className="overview-details">
            <p>Producten ({productCount})</p>
            <p>€ {totalPrice.toFixed(2)}</p>
          </div>
          <div className="overview-details">
            <p>Verzendkosten</p>
            <p>€ {shippingCost.toFixed(2)}</p>
          </div>
          {(totalPrice < 100) && (<p>Voeg nog&nbsp;<span className="yellow">€ {(100 - totalPrice).toFixed(2)}</span>&nbsp;toe om te profiteren van gratis bezorging!</p>)}
          <div className="overview-total">
            <p>Totaal:</p>
            <p>€ {(totalPrice + shippingCost).toFixed(2) }</p>
          </div>
          <Link to='/orderdetails'><button disabled={!hasItems} className="checkout-btn">Verder naar bestellen</button></Link>
          <div className="payment-icons">
            {/* Add your payment icons here */}
          </div>
          <div className='paymentIcons'>
            <img src={ideal} alt='ideal'></img>
            {/* <img src={paypal} alt='paypal'></img> */}
            <img src={visa} alt='visa'></img>
            <img src={mastercard} alt='mastercard'></img>            
          </div>
          <p className='paymentIconsP'><i class="bi bi-truck"></i> <strong>Gratis bezorging bij bestellingen vanaf €100</strong></p>
          <p className='paymentIconsP'><i class="bi bi-shop-window"></i> <strong>Bestel online & ophalen in de winkel (gratis)</strong></p>
        </div>
      </div>
    </div>
     </div>
     </>
  );
};

export default Cart;
